// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import rquest from './common/request.js'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)


new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
})




// WEBPACK FOOTER //
// ./src/main.js